import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import SideNav from './components/SideNav';
import Header from './components/Header';
import AppRoutes from './routes';
import LoginPage from './pages/LoginPage';
import { CssBaseline, useMediaQuery, useTheme, CircularProgress, Box } from '@mui/material';
import { AuthenticationProvider, useAuthentication } from './contexts/AuthenticationContext';

const drawerWidth = 240;

// Main authenticated layout with sidebar and header
function AuthenticatedLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div style={{ display: 'flex' }}>
      <Header onMenuClick={handleDrawerToggle} isMobile={isMobile} />
      <CssBaseline />
      <SideNav
        drawerWidth={drawerWidth}
        isMobile={isMobile}
        mobileOpen={mobileOpen}
        onClose={handleDrawerToggle}
      />
      <main style={{
        flexGrow: 1,
        padding: '16px',
        marginLeft: isMobile ? '0' : '20px',
        marginTop: '54px',
        width: isMobile ? '100%' : `calc(100% - ${drawerWidth}px)`
      }}>
        <AppRoutes />
      </main>
    </div>
  );
}

// App content that checks authentication state
function AppContent() {
  const { user, loading } = useAuthentication();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return <AuthenticatedLayout />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthenticationProvider>
        <AppContent />
      </AuthenticationProvider>
    </BrowserRouter>
  );
}

export default App;